import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  FormControlLabel,
  Grid,
  MenuItem,
  OutlinedInput,
  Radio,
  RadioGroup,
  useMediaQuery,
} from "@mui/material";
import Unit from "components/Unit/Unit.model";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import { Controller, useForm, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { getFocus, useGet } from "state/jotai";
import { active_project } from "state/store.global";
import { _project } from "state/store.projects";
import { useLocation } from "react-router-dom";
import { useFetch } from "hooks/fetch/useFetch";
import { motion } from "framer-motion";
import axios from "axios";
import { Icon } from "components/Icons";
import { ReactSelect } from "components/AdvanceDropdown/NormalDropdown/Dropdown";
import { PhoneNumberDropdown } from "components/AdvanceDropdown/PhoneNumberDropdown/Dropdown";
import { CheckBox } from "components/FormComponent/CheckBox";
import { SearchDropdown } from "components/AdvanceDropdown/SeachDropdown/Dropdown";
import { CustomPlaceHolderInputField } from "components/FormComponent/TextField";
import { CustomRadio } from "components/FormComponent/Radio";
import { CustomButton } from "components/Unit/NewReservationButton";
import { enqueueSnackbar } from "notistack";
import EusButton from "components/Button/EusButton";
import { useBreak } from "hooks/useBreak";
import { API, GETLEADTOKEN, POST_TESTLEAD } from "api/api";
import { SelectDate } from "components/FormComponent/SelectDate";
import { _bootstrap } from "state/store.bootstrap";
import SuccessMessage from "components/Contact/SuccessMessage";
import { CustomInput, CustomLabel, CustomRadioGroup, PlaceHolderInputField } from "components/Contact/styled-components";
import { boostrap } from "state/store.fullEido";
import { CheckboxField, CountryField, DateOfBirthField, EmailField, PhoneField, RadioField, SelectField, TextField } from "./FormField";



const ContactForm = ({ drawerType, grid, unit, campaignId, children, isDrawer = false }) => {
  const isFullEidoSite = ['frontpage', 'unitpage', 'propertypage']
  const boostrapData = useGet(boostrap)

  const projectID  = useGet(_bootstrap).projectids?.[0] || null
  
  const sm       = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const { i18n: { language }, } = useTranslation();

  const [personName, setPersonName] = useState([]);
  const [nationName, setNationName] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  const [describeName, setDescribeName] = useState([]);


  // const { submit, successMsg, errorMsg, inProgress, submitted } = useHubspot();
  const { register, handleSubmit, getValues, setValue, watch, control, reset, formState: { errors, isValid } } = useForm({ mode: 'onChange',
    defaultValues: {
      dateOfBirth: "",
      birth_date: "",
      birth_month: "",
      birth_year: "",
      // country_id: {
      //   "country_id": 47,
      //   "name_dk": "Danmark",
      //   "name_eng": "Denmark",
      //   "country_code": "+45",
      //   "iso_code": "DK",
      //   "value": `+45 ${language === "da" ? 'Danmark' : 'Denmark' }`,
      //   "label": `+45 ${language === "da" ? 'Danmark' : 'Denmark' }`
      // }
    },
   });
  const selected = useWatch({ control, name }) || [];

  const here = useLocation().pathname;

  const atUnit = here.includes("unit");
  const { pin, pid } = useGet(active_project) 
  const isMobile = useBreak('md_dn')
  
  const testLeadData = useFetch({ url: GETLEADTOKEN(campaignId) });

  const buttonsLabel  = getFocus(_project, 'buttonsLabel')?.[pin]?.[pid] ?? []

  const isDesktop = useMediaQuery('(min-width:1200px)');

  const unitNo = unit?.getValue("Projeknr") ? `${buttonsLabel?.filter( btn => btn?.UILabelProperty === 'Bolignr')[0]?.Label} ${unit.getValue("Projeknr")},` : "";
  const unitAddress = unit?.getAddress() ?? "";
  // const unitId = unit?.getId();
  const sys_uid = unit?.getValue('SVGID');
  const unitId = unit?.getId();
  const isRent = unit?.isRent()
  
  const homeUrl = window.location.origin;
  const unitUrl = unit?.getUrl(`${homeUrl}/${language}`) ?? "";
  
  
  const [checked, setChecked] = React.useState(false);
  const [checked2, setChecked2] = React.useState(false);


  useEffect(()=> {
      testLeadData.mutate()
  }, [language])

  useEffect(() => {
    if (submitted) {
      reset();
      setChecked(false);
      setChecked2(false)
    }
  }, [submitted]);

  const handleFormSubmit = async (data) => {


  let utmParam = {};
  for (let [key, value] of new URLSearchParams(location.search).entries()) {
    if(key === "utm_source" || key === "utm_medium" || key === "utm_campaign" || key === "utm_content") {
      utmParam[key] = value;
    }
  }
 
    // const leadNationality = testLeadData?.D?.countries?.filter((c) => c?.name_dk === data?.nationality_id || c?.name_eng === data?.nationality_id)
    // const leadCountry_code = testLeadData?.D?.countries?.filter((c) => c?.country_code === `+${data?.country_id.split("+")?.[1]}`)
    // const leadNationality = data?.nationality_id?.country_id

    const leadCountry_code = data?.country_id?.country_id
    const source = window.location.href;
    const media = isFullEidoSite.some((fe) => here.includes(fe));
    const isFES = media ? "Ei.DO website" : "Ei.DO boligvælger";
    const unitID =  unitId ? { B_ID: unitId} : {}
    const country = data?.country?.country_id
    
        const payload = new URLSearchParams({
           ...unitID,
          token: testLeadData?.D?.token,
          hash: testLeadData?.D?.hash,
          CAMPAIGN: 'a2528707edbeaacb293ed7aee8433aca',
          // SYS_UID: sys_uid,
          Fornavne: data.firstName,
          Efternavn: data.lastName,
          country_code: leadCountry_code,
          nationality_code: country,
          Email_privat: data.email,
          Telefon_mobil: data.phone,
          dob: data.dateOfBirth,
          media: isFES,
          source,
          // postnummer: data.postnummer,
          // Comments: data.kommentar?.length ? data.kommentar : "",
          ...utmParam
        });
        console.log(Object.fromEntries(payload), data)
      axios.post(`${testLeadData?.D?.system_domain}/${POST_TESTLEAD}`, payload, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then((data) => {
        setSubmitted(Object.keys(data || {}).length ? true : false);
        testLeadData.mutate()
        setPersonName([]);
        setNationName([]);
        setDescribeName([])

          // After success:
        const emptyValues = {};
        Object.entries(data).forEach(([key, value]) => {
          emptyValues[key] = typeof value === 'boolean' ? false : '';
        });
        
        reset(emptyValues);
        setChecked(false);
        setChecked2(false)
      })
      // .catch((err) => {
      //   enqueueSnackbar(language === "da" ? 'Noget gik galt. Prøv igen' : 'Something went wrong. Try again', { variant: 'error' });
      // });
      
  };

  const onSubmit = (data) => {
    handleFormSubmit(data);
  };

  // select dropdown configs
  
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;


  const MenuProps = {
    anchorOrigin: {
      vertical: "bottom",
      horizontal: !grid ? "right" : "left" // Don't pass grid from contact drawer as this condition won't work
    },
    transformOrigin: {
      vertical: "top",
      horizontal: !grid ? "right" : "left"
    },
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4 + ITEM_PADDING_TOP,
        // width: dropdown_width
      },
    },
  };

  // handling the field which should have only number allowed
  const handleNumberInput = (event) => {
    return (event.key.charCodeAt() >= 48 && event.key.charCodeAt() <= 57) || event.key === 'Backspace' ? event.key : event.preventDefault();
  }

  const FormComponent = {
    'text': (data) => <TextField { ...data} />,
    'email': (data) => <EmailField { ...data} />,
    'tel': (data) => <PhoneField { ...data} />,
    'date': (data) => <DateOfBirthField { ...data} />,
    'select': (data) => <SelectField { ...data} />,
    'radio': (data) => <RadioField { ...data} />,
    'checkbox': (data) => <CheckboxField { ...data} />,
    'country': (data) => <CountryField { ...data} />,
  }
  
  return (
    <>
      {submitted ? (
          <motion.div
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
        >
             <SuccessMessage label={atUnit ? false : false} labelName = {"Signupmessage"} msg={ language == 'da' ? 'Vi har modtaget din opskrivning - vi kontakter dig hurtigst muligt' : 'We have received your write-up - we will contact you as soon as possible.' } />
        </motion.div>
     
      ) : (
        <>
          <Box
            sx={{
              position: 'relative',
               color   : clr.sub_text_color,
            }}
          >
            {children}
            <form onSubmit={handleSubmit(onSubmit)} style={{ background: '#ffffffe6', borderRadius: '16px', padding: '16px' }}>
              <Grid
                container
                columnSpacing={3}
                rowSpacing={grid ? 2 : 1}
                sx={{ mb: 3 }}
              >
                {
                  boostrapData?.FooterForm?.fields?.map((form, i)=> {
                  
                    return <Grid item xs={12} sx={{ pt: i ? '0 !important' : '16px' }}>
                    <Grid>
                      <FormControl
                        sx={{ mb: 3, gap: '8px' }}
                        fullWidth
                        variant='filled'
                      >
                        <CustomLabel className="h5">
                          {form?.[0]?.label}
                          {/* &nbsp;<span>*</span> */}
                        </CustomLabel>
                        {
                          form?.[0]?.fields ?
                          form?.[0]?.fields?.length && form?.[0]?.fields?.[0].type === 'radio' ? 
                           <Controller
                              name={form?.[0]?.fields?.[0]?.name}
                              control={control}
                              rules={{ required: true }}
                              defaultValue=""
                              render={({ field }) => (
                                <CustomRadioGroup
                                  {...field}
                                  sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    flexWrap: { xs: "wrap", md: "nowrap" },
                                  }}
                                >
                                  {form?.[0]?.fields?.map((radioOption) => (
                                    <CustomRadio
                                      key={radioOption.label}
                                      value={radioOption.label}
                                      label={radioOption.label}
                                    />
                                  ))}
                                </CustomRadioGroup>
                              )}
                            />
                          : 
                          form?.[0]?.fields?.length && form?.[0]?.fields?.[0].type === 'checkbox' ? 
                           <>
                            <Controller
                                name={form?.[0]?.fields?.[0]?.name}
                                control={control}
                                defaultValue={[]}
                                rules={{ required: true }}
                                render={({ field: { onChange, onBlur, value = [], ref } }) => {
                                  const handleToggle = (val) => {
                                    if (value.includes(val)) {
                                      onChange(value.filter((v) => v !== val));
                                    } else {
                                      onChange([...value, val]);
                                    }
                                  };

                                  return (
                                    <>
                                      {form[0].fields.map((checkbox, index) => (
                                        <Box
                                          key={checkbox.value || index}
                                          sx={{ display: 'flex', alignItems: 'center', color: '#000', lineHeight: '1.3', mb: 1 }}
                                        >
                                          <CheckBox
                                            inputRef={ref}
                                            checked={value.includes(checkbox.value)}
                                            onChange={() => handleToggle(checkbox.value)}
                                            onBlur={onBlur}
                                          />
                                          <p className="paragraph2-light">{checkbox.placeholder}</p>
                                        </Box>
                                      ))}
                                    </>
                                  );
                                }}
                              />
                            </>
                          :
                          <Box sx={{ width: 'fit-content', gap: '16px', display: 'flex', flexWrap: 'wrap' }}>
                           
                            {
                              form?.[0]?.fields?.map((field) => {
                                return <>{ FormComponent[field?.type]({ ...field, errors, register, testLeadData, control, watch, getValues, setValue  }) }</>
                              })
                            }
                          </Box>

                          : FormComponent[form?.[0]?.type] && FormComponent[form?.[0]?.type]({ ...form?.[0], errors, register, testLeadData, control, watch, getValues, setValue  })
                        }
                      </FormControl>

                    </Grid>
                </Grid>
                  })
                }
                
              </Grid>

              {
                Object.keys(boostrapData?.FooterForm?.checkboxes?.length || {}) ?
                  <Box sx={{ mb: 3, display: "flex", flexDirection: "column", gap: "8px" }}>
                    <CustomLabel className="h5">
                      { buttonsLabel?.filter( btn => btn.UILabelProperty === 'FormularBetingelser')[0]?.Label }&nbsp;<span>*</span>
                    </CustomLabel>
                     <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                      {
                        boostrapData?.FooterForm?.checkboxes?.fields?.map((cb) => {
                          return <Controller
                            name={cb.name}
                            control={control}
                            defaultValue={false} 
                            rules={{ required: true }}
                            render={({ field, fieldState }) => (
                              <FormControlLabel
                                sx={{
                                  mr: 0,
                                  ml: 0,
                                  gap: '8px',
                                  alignItems: 'flex-start',
                                  "span": { color: '#000' },
                                  "a": { color: `${'#000'} !important` },
                                }}
                                control={
                                  <CheckBox
                                    {...field}
                                    checked={field.value}
                                    onChange={(e) => {
                                      field.onChange(e.target.checked);
                                      setChecked(e.target.checked);
                                    }}
                                  />
                                }
                                label={
                                  <div dangerouslySetInnerHTML={{ __html: cb?.label }} />
                                }
                              />
                            )}
                          />

                        })
                      }
                     </Box>
                  </Box>
                :
                <>j</>
              }
              <Box
                sx={{
                  position: { xs: !isDrawer ? 'unset' :"fixed", sm: "unset" },
                  bottom: 0,
                  left: 0,
                  width: "100%",
                  zIndex: '5',
                  "button": {
                    width: { xs: !isDrawer ? 'auto' : "100%", sm: "fit-content" },
                    height: { xs: isDrawer ? "60px" : "44px" , sm: "44px"},
                    padding: { xs: isDrawer ? "12px 40px 30px 40px" : "12px 40px" }
                  }
                }}
              >
             
              {
                sm && isDrawer
                ?
                <EusButton
                // {...props}
                clr={f_clr}
                type='submit'
                onClick={()=> {}}
                borderRadius={"16px 16px 0px 0px;"}
                variant={"primary"}
                iconName={"next-arrow"}
                backgroundColor={f_clr.ctaPrimary}
                // disabled={!checked || !isValid }
                disabled={!isValid }
                icon={true}
                size={12}
                iconAlign={"right"}
                buttonlabel={false}
                otherText={'Send'}
                iconSize={"xl"}
                isFaIcon={false}
              />
                :
                <CustomButton
                type='submit'
                className="eus-button-2"
                clr={f_clr}
                // disabled={!checked || !isValid}
                disabled={!isValid }
                variant = "primary"
                padding={"12px 24px"}          
              >
                  { buttonsLabel?.filter( btn => btn.UILabelProperty === 'signUp')[0]?.Label || 'Tilmeld' }
              </CustomButton>
              }
              </Box>
            </form>
          </Box>
        </>
      )}
    </>
  )
};

ContactForm.propTypes = {
  children: PropTypes.node,
  grid: PropTypes.bool,
  unit: PropTypes.instanceOf(Unit),
};

export default ContactForm;


const field =  [
            [
                {
                    "name": "firstLastName",
                    "label": "Full name",
                    "fields": [
                        {
                            "name": "firstName",
                            "label": "First name and middle name",
                            "type": "text",
                            "placeholder": "First name and middle name",
                            "errorText": "Please enter valid first name",
                            "required": true
                        },
                        {
                            "name": "lastName",
                            "label": "Last name",
                            "type": "text",
                            "placeholder": "Last name",
                            "errorText": "Please enter valid last name",
                            "required": true
                        }
                    ]
                }
            ],
            [
                {
                    "name": "email",
                    "label": "Private e-mail",
                    "type": "email",
                    "placeholder": "E-mail",
                    "errorText": "Please enter valid email",
                    "required": true
                }
            ],
            [
                {
                    "name": "country",
                    "label": "Country",
                    "type": "select",
                    "errorText": "Please select valid option",
                    "placeholder": "Country",
                    "options": [
                        "Denmark",
                        "Germany",
                        "Sweden",
                        "Norway"
                    ],
                    "required": true
                }
            ],
            [
                {
                    "name": "phone",
                    "label": "Phone number",
                    "type": "tel",
                    "placeholder": "Phone",
                    "errorText": "Please enter valid phone number",
                    "required": true
                }
            ],
            [
                {
                    "name": "birthDate",
                    "label": "Date of birth",
                    "type": "date",
                    "errorText": "Please select valid date",
                    "required": true,
                    "subfields": {
                        "day": {
                            "name": "dob_day",
                            "type": "select",
                            "placeholder": "Date"
                        },
                        "month": {
                            "name": "dob_month",
                            "type": "select",
                            "placeholder": "Month"
                        },
                        "year": {
                            "name": "dob_year",
                            "type": "select",
                            "placeholder": "Year"
                        }
                    }
                }
            ],
            [
            {
                "name": "checkbox",
                "label": "checkbox",
                "errorText": "Please select valid option",
                "required": true,
                "fields": [
                    {
                        "name": "checkbox",
                        "label": "checkbox op 1",
                        "type": "checkbox",
                        "placeholder": "checkbox op 1",
                        "required": true
                    },
                    {
                        "name": "checkbox",
                        "label": "checkbox op 2",
                        "type": "checkbox",
                        "placeholder": "checkbox op 2",
                        "required": true
                    }
                ]
            }
        ],
        [
            {
                "name": "radio",
                "label": "radio",
                "required": true,
                "errorText": "Please select valid option",
                "fields": [
                    {
                        "name": "radio",
                        "label": "radio op 1",
                        "type": "radio",
                        "placeholder": "radio op 1",
                        "required": true
                    },
                    {
                        "name": "radio",
                        "label": "radio op 2",
                        "type": "radio",
                        "placeholder": "radio op 2",
                        "required": true
                    }
                ]
            }
        ],
        ]